import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ItButtonDirective } from "design-angular-kit";

@Component({
    selector: "app-confirm-delete",
    standalone: true,
    imports: [TranslateModule, ItButtonDirective],
    templateUrl: "./confirm-delete.component.html",
})
export class ConfirmDeleteComponent {
    constructor(public activeModal: NgbActiveModal) {}

    onConfirm(): void {
        this.activeModal.close(true);
    }

    onClose(): void {
        this.activeModal.dismiss(false);
    }
}
